export enum IRole {
    Supervisor,
    Operator,
    Admin,
}